import { ILineItem } from '~/lib/data-contract';
import { useFormattedPrice } from '~/shared/hooks/useFormattedPrice';

import styles from './lineItemPrice.module.css';

export { styles as lineItemPriceStyles };

export type LineItemPriceProps = Pick<ILineItem, 'discountedLinePrice' | 'linePrice' | 'discount'>;

export const LineItemPrice = ({ discountedLinePrice, linePrice, discount }: LineItemPriceProps) => {
	const formattedLinePrice = useFormattedPrice(linePrice, true);
	const formattedDiscountedLinePrice = useFormattedPrice(discountedLinePrice, true);
	const formattedSavings = useFormattedPrice(discount ? -discount : undefined, true);

	const isDiscounted = Boolean(discount);

	return (
		<div className={styles.root}>
			{isDiscounted ? (
				<>
					<span
						className={styles.priceOld}
						data-line-item-price
					>
						{formattedLinePrice}
					</span>
					<span
						className={styles.priceSaved}
						data-line-item-price
					>
						{formattedSavings}
					</span>
					<span
						className={styles.priceActual}
						data-line-item-price
					>
						{formattedDiscountedLinePrice}
					</span>
				</>
			) : (
				<span
					className={styles.priceActual}
					data-line-item-price
				>
					{formattedLinePrice}
				</span>
			)}
		</div>
	);
};
